/* eslint-disable jsx-a11y/label-has-for,import/no-extraneous-dependencies */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styledComponent from '../../../utils/styledComponent';

const StyledDiv = styledComponent('div', {
  '& .psudeoLabel': {
    color: '#4a4a4a',
    fontSize: '18px',
    marginBottom: '10px',
    width: 'auto',
  },
  '& .tray': {
    background: '#ccc',
    borderRadius: '22px',
    display: 'block',
    height: '14px',
    marginBottom: '20px',
    position: 'relative',
    width: '55px',
  },
  '& input': {
    '& + label': {
      '&:hover': {
        cursor: 'pointer',
      },
      borderRadius: '14px',
      left: 0,
      marginBottom: '10px',
      position: 'absolute',
      top: '-5px',
      transition: '.3s',
    },
    '&:checked + label': {
      backgroundColor: '#2DB6E9',
      left: '30px',
    },
    height: '40px',
    visibility: 'hidden',
    width: '55px',
  },
  '& label': {
    backgroundColor: '#9c9c9c',
    display: 'block',
    height: '25px',
    textIndent: '-9000px',
    top: '34px',
    width: '25px',
  },
});

const Toggle = ({ field: { name, value, onChange, onBlur }, id, label }) => {
  const [isChecked, setIsChecked] = useState(value);
  return (
    <StyledDiv>
      <div className="psudeoLabel">{label}</div>
      <div
        className="tray"
        onClick={() => {
          setIsChecked(!isChecked);
          onChange({ target: { id, value: !isChecked } });
        }}
      >
        <input
          name={name}
          id={id}
          type="checkbox"
          value={value || 'false'}
          checked={isChecked}
          onChange={() => {}}
          onBlur={onBlur}
        />
        <label id={name} htmlFor={name}>
          {label}
        </label>
      </div>
    </StyledDiv>
  );
};

Toggle.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    value: PropTypes.bool,
  }).isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default Toggle;
